 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"change-password~check-email~email-confirmed~events~login~recovery~registration-success~reset-success":"change-password~check-email~email-confirmed~events~login~recovery~registration-success~reset-success","change-password~check-email~email-confirmed~login~recovery~registration-success~reset-success":"change-password~check-email~email-confirmed~login~recovery~registration-success~reset-success","change-password":"change-password","check-email":"check-email","email-confirmed":"email-confirmed","login":"login","recovery":"recovery","registration-success":"registration-success","reset-success":"reset-success","events":"events","content-item~request~shop":"content-item~request~shop","content-item":"content-item","profile~registration~request":"profile~registration~request","request~shop":"request~shop","request":"request","shop":"shop","documents":"documents","index":"index","not-found":"not-found","orders":"orders","orders-detail":"orders-detail","payment":"payment","profile~registration~user":"profile~registration~user","profile":"profile","registration":"registration","user":"user","static-page~stream":"static-page~stream","static-page":"static-page","stream":"stream"}[chunkId]||chunkId) + "." + {"change-password~check-email~email-confirmed~events~login~recovery~registration-success~reset-success":"be78addb","change-password~check-email~email-confirmed~login~recovery~registration-success~reset-success":"1feb80fa","change-password":"ca5f9bd7","check-email":"a8ea92f7","email-confirmed":"d21b2e78","login":"6e806916","recovery":"2ef75728","registration-success":"4d74ff61","reset-success":"49e5559a","events":"7a58c462","chunk-29073c42":"3bec9d59","content-item~request~shop":"c256fb27","content-item":"2b6cf2f2","profile~registration~request":"9b5b6ae4","request~shop":"6984acab","request":"f27c18e5","shop":"27729ab1","documents":"340028ae","index":"0df7eadd","not-found":"ce0a525f","orders":"8e7543d5","orders-detail":"b000507c","payment":"eb4739ce","profile~registration~user":"9ce8f812","profile":"9aa6df6a","registration":"f5694d0f","user":"16368789","static-page~stream":"32422833","static-page":"3cb59b72","stream":"a77568d8"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"change-password~check-email~email-confirmed~events~login~recovery~registration-success~reset-success":1,"change-password~check-email~email-confirmed~login~recovery~registration-success~reset-success":1,"change-password":1,"check-email":1,"email-confirmed":1,"login":1,"recovery":1,"registration-success":1,"reset-success":1,"events":1,"chunk-29073c42":1,"content-item~request~shop":1,"content-item":1,"profile~registration~request":1,"request~shop":1,"request":1,"shop":1,"documents":1,"index":1,"not-found":1,"orders":1,"orders-detail":1,"payment":1,"profile~registration~user":1,"profile":1,"registration":1,"user":1,"static-page~stream":1,"static-page":1,"stream":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"change-password~check-email~email-confirmed~events~login~recovery~registration-success~reset-success":"change-password~check-email~email-confirmed~events~login~recovery~registration-success~reset-success","change-password~check-email~email-confirmed~login~recovery~registration-success~reset-success":"change-password~check-email~email-confirmed~login~recovery~registration-success~reset-success","change-password":"change-password","check-email":"check-email","email-confirmed":"email-confirmed","login":"login","recovery":"recovery","registration-success":"registration-success","reset-success":"reset-success","events":"events","content-item~request~shop":"content-item~request~shop","content-item":"content-item","profile~registration~request":"profile~registration~request","request~shop":"request~shop","request":"request","shop":"shop","documents":"documents","index":"index","not-found":"not-found","orders":"orders","orders-detail":"orders-detail","payment":"payment","profile~registration~user":"profile~registration~user","profile":"profile","registration":"registration","user":"user","static-page~stream":"static-page~stream","static-page":"static-page","stream":"stream"}[chunkId]||chunkId) + "." + {"change-password~check-email~email-confirmed~events~login~recovery~registration-success~reset-success":"bb2773a6","change-password~check-email~email-confirmed~login~recovery~registration-success~reset-success":"1a2ae543","change-password":"22fb7c21","check-email":"899be257","email-confirmed":"9a9de28a","login":"22fb7c21","recovery":"22fb7c21","registration-success":"9a9de28a","reset-success":"9a9de28a","events":"f9cd8d9c","chunk-29073c42":"9cb683ea","content-item~request~shop":"9efc09ff","content-item":"d8ea0bfb","profile~registration~request":"2048215c","request~shop":"73a32223","request":"a2859438","shop":"186cbf10","documents":"27a1f9bc","index":"cd99f351","not-found":"f50cfb56","orders":"11992ac6","orders-detail":"ea5f2f6e","payment":"c36c525e","profile~registration~user":"dab55ab1","profile":"11013aff","registration":"c0d8c1c4","user":"2baa6778","static-page~stream":"138fb6a9","static-page":"ca0a26b5","stream":"e3be1336"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
